<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import FormSteps from '@/Components/FormSteps/FormSteps.vue';


defineProps({
    title: String,
    currentStep: Number,
});

const steps = [
    {id: 1, name: 'Customer Data', href: route('onboarding.step1'), status: 'complete'},
    {id: 2, name: 'Risk Profile', href: route('onboarding.step2'), status: 'current'},
    {id: 3, name: 'Assets', href: route('onboarding.step3'), status: 'upcoming'},
    {id: 4, name: 'Completion', href: route('onboarding.step4'), status: 'upcoming'},
]

</script>

<template>
    <AppLayout :title="title" :onBoardingActive="true">

        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <FormSteps :steps="steps" :current-step="currentStep"></FormSteps>
        </div>

        <div class="pt-6">
            <slot/>
        </div>

    </AppLayout>
</template>
